<template>
  <div class="DetailCaption">
    <div class="caption">
      <div class="caption-tab _user-select">
        <div
          v-for="vo in tab"
          :key="vo.id"
          :class="{ 'ON' : vo.id === tabId }"
          class="tab-item"
          @click="toggleCaption(vo.id)"
        >
          {{ vo.label }}
          <i class="bar" :class="[ vo.id === tabId ? 'ON':'NO' ]"/>
        </div>
      </div>
      <div
        :class="[{ 'NO': !isUnfold },
          {'AUTO':tabId === TUPIAN_DETAIL.CAPTION.TAB[2].id }
        ]"
        class="caption-content"
      >

        <i
          v-show="tabId != TUPIAN_DETAIL.CAPTION.TAB[2].id && tabId != 5"
          :class="{ 'ON': isUnfold } "
          class="i iconfont icon-a-arrowright"
          @click="isUnfold = !isUnfold"
        />

        <template v-if="tabId === TUPIAN_DETAIL.CAPTION.TAB[0].id">
          <div class="statement">

            {{
              detail.is_ai == 1 ? '潮国创意是商用版权素材库，该内容通过人工智能技术AI生成，潮国创意对该内容独立拥有相关权利并有权在法律许可范围内允许潮国创意用户依据所获授权使用。' : TUPIAN_DETAIL.CAPTION.STATEMENT[0]
            }}<br>

            {{ TUPIAN_DETAIL.CAPTION.STATEMENT[1] }} <br>



            图片说明：潮国创意是目前国内为设计师、创意机构和创作人员寻找高质量、吸睛创意设计资源的地方。
            此作品是 {{ detail.title }}  {{ detail.module_name? '+'+ detail.module_name : '' }}，文件格式是：{{ detail.layout_name ? disposeLayoutName(detail.layout_name) : 'JPG/PNG'}}，图片大小是：{{ detail.file_size }}MB，图片尺寸是：{{ detail.image_width }}px*{{ detail.image_height }}px，
            作品涉及的标签：{{ detail.keyword }} 。潮国创意提供：精美海报、3D作品、24节气、节日、时间轴更新等丰富图片种类，下载可用于网站、APP、印刷物料等多场景的商业作品，每日更新，敬请期待。
          </div>
        </template>


        <template v-if="tabId === TUPIAN_DETAIL.CAPTION.TAB[1].id && detail.is_dangjian == 1">
          <div class="explain"
               :class="{ 'overflow-more' : !isUnfold }"
          >
            {{ TUPIAN_DETAIL.CAPTION.EXPLAIN[0] }} <br>
            {{ TUPIAN_DETAIL.CAPTION.EXPLAIN[1] }}
          </div>
        </template>

        <template v-if="tabId === 5 ">
          <div class="explain"

          >
            肖像权：潮国创意已获得肖像权 （如需使用在烟草、医疗、药物、整容、保健品类等敏感领域广告和宣传，请点击 <a href="/pay-company-plus/12" class="tagg" target="_blank">企业PLUS</a> 获取授权。
          </div>
        </template>


        <template v-show="tabId === TUPIAN_DETAIL.CAPTION.TAB[2].id">
          <div class="pic-tag"
             :class="{ 'ON': tabId === TUPIAN_DETAIL.CAPTION.TAB[2].id }"
             v-if="detail._keyword_pinyin && detail._keyword_pinyin.length">
          <a
            :href=" PAGE_PATH.BASE_URL + PAGE_PATH.TUPIAN_LIST + '/' + vo.pinyin + '.html' "
            :title="vo.keyword"
            target="_blank"
            v-for="(vo,idx) in detail._keyword_pinyin" :key="idx"
          >{{ vo.keyword }}
          </a>
          <br>

          <template v-if="seo_words.length">
            <a
              :href=" vo.link "
              :title="vo.keyword"
              target="_blank"
              v-for="(vo,idx) in seo_words" :key="idx"
            >{{ vo.keyword }}
            </a>
          </template>
        </div>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import {TUPIAN_DETAIL} from "@/constant/tupian/TUPIAN_DETAIL";
import {PAGE_PATH} from "@/constant/PAGE_PATH";

export default {
  name: "DetailCaption",
  filters: {
    disposeLayoutName(val) {
      if (Array.isArray(val)) {
        return val.join(' / ')
      } else {
        return val;
      }
    },
    disposekeywordList(val) {
      if (Array.isArray(val)) {
        return val.join('、')
      } else {
        return val;
      }
    },
  },
  props: {
    /* 详情 */
    detail: {
      type: Object,
      default: () => {
      }
    },
    seo_words:{
      type: Array,
      default: () => {
      }
    },
    isSpider:{
      type:Boolean,
      default: false
    }
  },
  watch: {
    detail: {
      handler(n, o) {
        if (n) {
          // n.is_protrait = 1;
          console.log(n)
          let temTab = TUPIAN_DETAIL.CAPTION.TAB.slice();

          if (n.is_dangjian != '1') {
            this.tab = temTab.filter(vo => vo.id != 2)
          } else {
            this.tab = temTab
          }

          if (n.is_dangjian == 1){
            this.tabId = 2;
          }


          if (n.is_protrait == 1){
            this.tab.push({
              label: '肖像权',
              id:5
            })
          }
        }

      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      tabId: 1,
      TUPIAN_DETAIL,
      tab: [],
      isUnfold: false, // 是否展开
      PAGE_PATH
    }
  },
  methods: {
    toggleCaption(id) {
      this.tabId = id;
      this.isUnfold = false
    },
    disposeLayoutName(val) {
      if (Array.isArray(val)) {
        return val.join(' / ')
      } else {
        return val;
      }
    },
  }

}
</script>

<style lang="scss" scoped>
.DetailCaption {
  margin-bottom: 40px;

  .caption {

    .caption-tab {
      display: flex;
      margin-bottom: 10px;

      .tab-item {
        font-size: 13px;
        color: #596088;
        line-height: 18px;
        margin-right: 16px;
        position: relative;
        cursor: pointer;

        &.ON {
          color: #0A2540;
        }

        &.NO {
          .bar {
            width: 0;
            transition: all 0.5s ease-in;
          }
        }


        .bar {
          width: 20px;
          height: 3px;
          background: #6969FF;
          border-radius: 2px;
          @include Position(1, 4, 50%, -5px);
          transform: translateX(-50%);
          //transition: all 0.5s ease-in;

          &.NO {
            width: 0;
            transition: all 0.3s ease-in;
          }

          &.ON {
            width: 20px;
            transition: all 0.5s ease-in;
          }


        }
      }
    }

    .caption-content {
      max-width: 625px;
      position: relative;
      //height: 60px;
      color: rgba(89, 96, 136, 0.8);
      line-height: 20px;

      &.NO {
        height: 40px;

        .statement, .explain {
          height: 40px;
          overflow: hidden;
        }
      }

      &.NO {
        height: auto;
      }

      .statement {
        //height: 160px;
      }

      .explain {
        //height: 80px;
      }
      .tagg{
        color: $color-primary;
        text-decoration: underline;
      }

      .statement, .explain {
        line-height: 20px;
        transition: all 0.2s ease-in;

      }

      .icon-a-arrowright {
        font-size: 16px;
        @include Position(1, 2, -33px, 0px);
        transform: rotate(90deg);
        cursor: pointer;
        transition: all 0.3s ease-in;

        &.ON {
          transform: rotate(270deg);
        }

        &:hover {
          color: $color-primary;
        }
      }

    }
  }
}

.pic-tag {
  display: flex;
  flex-wrap: wrap;
  width: 660px;
  opacity: 0;
  height: 0;

  &.ON {
    opacity: 1;
    height: auto;
  }

  a {
    //width: 42px;
    padding: 0 8px;
    height: 26px;
    line-height: 26px;
    background: #F5F6FA;
    border-radius: 13px;
    font-size: 13px;
    color: #596088;
    margin: 0 8px 8px 0;

    @include ElementHover(#6969FF, #EEEEFF);

  }
}
</style>
